module.exports = __webpack_public_path__ + "img/制御工学7_3_1.a2c1e944.png";